<div class="basicrow f-black rel">
  <div class="basicrow roboto-b">
    <div class="popterm-title  pdd-popUp">
      <div class="basicrow termless">
        Términos y Condiciones de la oferta
        <label class="ClaroTvTitle">Claro</label><label class="tvmasTitle">tv+</label>
      </div>
      <img width="100%" class="xtermcloser" (click)="this.close();" src="../../assets/images/xtermclose.png">
    </div>
  </div>
  <div class="sprt-bline"></div>
  <div class="basicrow f-reg roboto-r container-pop">
    <div class="pdd-popUp" style="text-align: justify;" [innerHTML]="this.contentHtml"></div>
  </div>
  <div class="centradoMaterial1 basicrow padbtnspace" [hidden]="!this.btm">
    <button class="btm-print" (click)="this.print()" *ngIf="this.btmPrint==true">
      {{this.labelPrint}} &nbsp;&nbsp;
      <i class="fa fa-angle-right" aria-hidden="true"></i>
    </button>

    <button class="btn-accept" (click)="this.continue()">
      {{this.labelContinue}} &nbsp;&nbsp;
      <i class="fa fa-angle-right" aria-hidden="true"></i>
    </button>

    <button class="btm-cancel" (click)="this.cancel()">
      {{this.labelCancel}} &nbsp;&nbsp;
      <i class="fa fa-angle-right" aria-hidden="true"></i>
    </button>
  </div>
  <div class="basicrow m-top f-reg roboto-b txt-center">
    Copyright © 2021 Puerto Rico Telephone Company, Inc.
  </div>
  <div class="sprt-bline-popUp"></div>
</div>
